import React from 'react';

import { Global } from '@emotion/react';
import styled from '@emotion/styled';

import { callNativeHandler } from '@myrealtrip/marketing-log';
import { NavigationTitle, Icon, UnstyledButton } from '@myrealtrip/web-ui';

import Show from '~components/Show';
import { useWebView } from '@myrealtrip/device-detect';
import errorGlobalStyle from '~styles/errorGlobals';

export default function NotFound() {
  const { isWebView } = useWebView();

  const handleCloseSearch = () => {
    try {
      callNativeHandler('close');
    } catch (error) {
      window.close();
    }
  };

  return (
    <ErrorContainer>
      <Global styles={errorGlobalStyle} />
      <Show when={isWebView}>
        <CustomNavigationTitle
          type="oneDepth"
          justify="flex-start"
          rightGroup={
            isWebView && (
              <Button onClick={handleCloseSearch}>
                <Icon name="IcoClose" />
              </Button>
            )
          }
        />
      </Show>
      <ErrorCover>
        <ErrorHeader className="error-text">
          <ErrorTitle>404</ErrorTitle>
          <ErrorDescription>해당 요청이나 데이터를 찾을 수 없습니다.</ErrorDescription>
        </ErrorHeader>
        <ErrorImage src="/transportation/assets/404Image.png" alt="Lighthouse" />
      </ErrorCover>
    </ErrorContainer>
  );
}

const ErrorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 60px 0;
  min-height: 500px;

  @media (min-width: 768px) {
    padding: 0;
  }
`;

const CustomNavigationTitle = styled(NavigationTitle)`
  position: absolute;
  top: 0;
  left: 0;
`;

const Button = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;

  & svg {
    fill: ${({ theme }) => theme.colors.gray.s1000};
  }
`;

const ErrorCover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 600px;
  max-width: 100%;
`;

const ErrorHeader = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Malgun Gothic', '맑은 고딕', Roboto, Helvetica,
    Arial, sans-serif;
  padding: 0 15px;
  width: 100%;
`;

const ErrorTitle = styled.h2`
  color: #666d75;
  font-family: inherit;
  font-weight: 500;
  font-size: 58px;
  margin: 0;
`;

const ErrorDescription = styled.p`
  margin: 0;
  font-size: 18px;
  color: #666d75;
`;

const ErrorImage = styled.img`
  width: 100%;
  max-width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;
